'use strict';

var React = require('react');

var SvgUpdateInventoryMajor = function SvgUpdateInventoryMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m18 5.65-8-3.555-8 3.555v13.35h-2v-14c0-.396.232-.753.594-.913l9-4a.999.999 0 0 1 .812 0l9 4a1 1 0 0 1 .594.913v14h-2v-13.35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 15a.997.997 0 0 1-.707-.293l-2-2a1 1 0 0 1 1.414-1.414l1.293 1.293 3.293-3.293a1 1 0 1 1 1.414 1.415l-4 4a.999.999 0 0 1-.707.292z"
  }));
};

exports.SvgUpdateInventoryMajor = SvgUpdateInventoryMajor;
